import axios from 'axios';

// El token se lee en cada peticion (interceptor), no al cargar el modulo: si se
// capturara una sola vez aqui, una carga antes del login mandaria "Bearer null" el
// resto de la sesion, y un refresh de token nunca se reflejaria. Mismo criterio que
// ya usa el cliente de Apollo en src/index.jsx (authLink).
const createAuthorizedClient = baseURL => {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use(config => {
    const token = localStorage.getItem('SHERPA_AUTH_JWT_ID');
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    return config;
  });

  return instance;
};

export default createAuthorizedClient;
